module.exports = __webpack_public_path__ + "img/law1m-m@1.01cd8567.jpg";